export function OutlineTraficoIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00477 19H4.00317V19.9984H6.00477V19Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0016 19H12V19.9984H14.0016V19Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.50073 16.5039H6.50393"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5007 16.5039H12.5039"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 14.0039H15"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0016 13H18V13.9984H20.0016V13Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5007 10.5039H18.4991"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 14.2288V18.04C15 18.5728 14.5728 19 14.04 19H3.96C3.432 19 3 18.5728 3 18.04V14.2288C3 14.08 3.0384 13.9312 3.1008 13.7968L4.7376 10.5328C4.9008 10.2064 5.232 10 5.5968 10H12.408C12.7728 10 13.104 10.2064 13.2672 10.5328L14.5008 13L14.8992 13.7968C14.9664 13.9312 15 14.08 15 14.2288Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 8.2288V12.04C21 12.5728 20.5728 13 20.04 13H14.5008L13.2672 10.5328C13.104 10.2064 12.7728 10 12.408 10H9V8.2288C9 8.152 9.0096 8.0752 9.0288 8.0032C9.0432 7.9312 9.072 7.864 9.1008 7.7968L10.7376 4.5328C10.9008 4.2064 11.232 4 11.5968 4H18.408C18.7728 4 19.104 4.2064 19.2672 4.5328L20.8992 7.7968C20.9328 7.864 20.9568 7.9312 20.976 8.0032C20.9904 8.0752 21 8.152 21 8.2288Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 8.00391H21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
